// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[6].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[6].use[2]!../../breakpoints.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_wrapper__5HQ0A {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    /*align-items: center;*/
    grid-gap: 24px;
    padding: 0 var(--container-padding) 100px;
    margin: auto;
    width: var(--container-width);
    max-width: 100%;
}

.styles_box__1o8sO {
    text-align: center;
    width: 210px;
}

.styles_box__1o8sO img {
    height: 150px;
    max-width: 150px;
}

.styles_box__1o8sO p {
    width: 90%;
    margin: auto;
    line-height: 18px;
    color: #000;
}

.styles_button__0xvPj {
    color: #fff;
    border: 1px solid var(--primary-color);
    background: var(--primary-color);
    border-radius: 10px;
    font-size: 14px;
    cursor: pointer;
    padding: 0 40px;
    transition:
        background-color 0.4s,
        border-color 0.4s;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 40px;
    margin: 24px 0 16px;
}

.styles_button__0xvPj:hover {
    color: #fff;
    background-color: var(--primary-color-active);
    border-color: var(--primary-color-active);
}

@media ${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-lg-min"]} {
    .styles_button__0xvPj {
        height: 44px;
        font-size: 16px;
        margin: 34px 0;
    }

    .styles_box__1o8sO p {
        line-height: 24px;
    }
}

@media ${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-lg-min"]} {
    .styles_wrapper__5HQ0A {
        grid-gap: 46px;
    }

    .styles_box__1o8sO {
        width: 280px;
    }

    .styles_box__1o8sO img {
        height: 232px;
        max-width: 232px;
    }

    .styles_box__1o8sO p {
        width: 80%;
    }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Options/styles.module.css"],"names":[],"mappings":"AAEA;IACI,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,uBAAuB;IACvB,cAAc;IACd,yCAAyC;IACzC,YAAY;IACZ,6BAA6B;IAC7B,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,sCAAsC;IACtC,gCAAgC;IAChC,mBAAmB;IACnB,eAAe;IACf,eAAe;IACf,eAAe;IACf;;yBAEqB;IACrB,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,6CAA6C;IAC7C,yCAAyC;AAC7C;;AAEA;IACI;QACI,YAAY;QACZ,eAAe;QACf,cAAc;IAClB;;IAEA;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,cAAc;IAClB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,aAAa;QACb,gBAAgB;IACpB;;IAEA;QACI,UAAU;IACd;AACJ","sourcesContent":["@value screen-lg-min from '../../breakpoints.css';\n\n.wrapper {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    /*align-items: center;*/\n    grid-gap: 24px;\n    padding: 0 var(--container-padding) 100px;\n    margin: auto;\n    width: var(--container-width);\n    max-width: 100%;\n}\n\n.box {\n    text-align: center;\n    width: 210px;\n}\n\n.box img {\n    height: 150px;\n    max-width: 150px;\n}\n\n.box p {\n    width: 90%;\n    margin: auto;\n    line-height: 18px;\n    color: #000;\n}\n\n.button {\n    color: #fff;\n    border: 1px solid var(--primary-color);\n    background: var(--primary-color);\n    border-radius: 10px;\n    font-size: 14px;\n    cursor: pointer;\n    padding: 0 40px;\n    transition:\n        background-color 0.4s,\n        border-color 0.4s;\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 40px;\n    margin: 24px 0 16px;\n}\n\n.button:hover {\n    color: #fff;\n    background-color: var(--primary-color-active);\n    border-color: var(--primary-color-active);\n}\n\n@media screen-lg-min {\n    .button {\n        height: 44px;\n        font-size: 16px;\n        margin: 34px 0;\n    }\n\n    .box p {\n        line-height: 24px;\n    }\n}\n\n@media screen-lg-min {\n    .wrapper {\n        grid-gap: 46px;\n    }\n\n    .box {\n        width: 280px;\n    }\n\n    .box img {\n        height: 232px;\n        max-width: 232px;\n    }\n\n    .box p {\n        width: 80%;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"screen-lg-min": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-lg-min"]}`,
	"wrapper": `styles_wrapper__5HQ0A`,
	"box": `styles_box__1o8sO`,
	"button": `styles_button__0xvPj`
};
export default ___CSS_LOADER_EXPORT___;
